/*******************************************************************************
  HeadingSubText.js

  Author: Advait

*******************************************************************************/
import React from "react";
import "../index.css";

/**
 * Adds subtext below a heading in ().
 * @param {*} props
 * @returns span component with subtext
 */
function HeadingSubText(props) {
  const style = {
    display: "block",
    width: "200px",
    fontSize: "smaller",
    color: "#8D969E",
  };

  return <span style={style}>({props.text})</span>;
}

export default HeadingSubText;
